import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import {
  Card,
  Col,
  Container,
  Nav,
  Row,
  TabContainer,
  TabContent,
  TabPane,
} from "react-bootstrap";
import axios from "axios";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";
import ConfirmModal from "./ConfirmModal";

import About_ihfc from "./about_program/About_ihfc";
import About_program from "./about_program/About_program";
import Program_schedule from "./about_program/Program_schedule";
import Team_oriented from "./about_program/Team_oriented";
import Spoc_details from "./about_program/Spoc_Details";
import Wifi_Access from "./about_program/Wifi_Access";
import Accommodation_Info from "./about_program/Accommodation_Info";
import Food_timings from "./about_program/Food_timings";
import Learning_Outcomes from "./about_program/Learning_Outcomes";
import See_Visit from "./about_program/SEE_visit";
import { Location_Details } from "./about_program/Location_Details";


// const tabConfig = (course) => [
//   {
//     id: "ihfc",
//     label: "About IHFC",
//     component: <About_ihfc program_id={course?.school_code} />,
//   },
//   {
//     id: "description",
//     label: "About Program",
//     component: <About_program program_id={course?.school_code} />,
//   },
//   {
//     id: "schedule",
//     label: "Program Schedule",
//     component: <Program_schedule program_id={course?.school_code} />,
//   },
//   {
//     id: "see_visit",
//     label: "SEE Visit",
//     component: <See_Visit program_id={course?.school_code} />,
//   },
//   {
//     id: "teamProjects",
//     label: "Team-Oriented Projects",
//     component: <Team_oriented program_id={course?.school_code} />,
//   },
//   {
//     id: "learning_outcomes",
//     label: "Learning Outcomes",
//     component: <Learning_Outcomes program_id={course?.school_code} />,
//   },
//   {
//     id: "location",
//     label: "Location Details",
//     component: <Location_Details program_id={course?.school_code} />,
//   },
//   {
//     id: "spoc_details",
//     label: "SPOC Details",
//     component: <Spoc_details program_id={course?.school_code} />,
//   },
//   {
//     id: "wifi_access",
//     label: "Wifi Access",
//     component: <Wifi_Access program_id={course?.school_code} />,
//   },
//   {
//     id: "accommodation",
//     label: "Accommodation",
//     component: <Accommodation_Info program_id={course?.school_code} />,
//   },
//   {
//     id: "food_timings",
//     label: "Refreshments Timings",
//     component: <Food_timings program_id={course?.school_code} />,
//   },
// ];

const tabConfig = [
  { id: "ihfc", label: "About IHFC", component: About_ihfc },
  { id: "description", label: "About Program", component: About_program },
  { id: "schedule", label: "Program Schedule", component: Program_schedule },
  { id: "see_visit", label: "SEE Visit", component: See_Visit },
  { id: "teamProjects", label: "Team-Oriented Projects", component: Team_oriented },
  { id: "learning_outcomes", label: "Learning Outcomes", component: Learning_Outcomes },
  { id: "location", label: "Location Details", component: Location_Details },
  { id: "spoc", label: "SPOC Details", component: Spoc_details },
  { id: "wifi", label: "Wi-Fi Access", component: Wifi_Access },
  { id: "accommodation", label: "Accommodation Info", component: Accommodation_Info },
  { id: "food", label: "Food Timings", component: Food_timings },
];

const PGT_lesson = () => {
  const item = useLocation();
  // console.log(item,"productdetails............");
  // console.log(JSON.parse(localStorage.getItem("upcomingCourse")));
  const course = JSON.parse(localStorage.getItem("upcomingCourse")) || item?.state?.course
  // console.log(course, "course............");

  const [isAlreadyEnrolled, setIsAlreadyEnrolled] = useState(false)
  const [showModal, setShowModal] = useState(false);

  const [activeKey, setActiveKey] = useState("ihfc");
  
  const ActiveComponent = tabConfig?.find(tab => tab?.id === activeKey)?.component;


  const handleEnrollClick = () => {
    setShowModal(true); // Show the custom modal
  };

  const alreadyEnrolled = async () => {
    try {
      const response = await axios.post(webServiceUrl.alreadyEnrolled, {
        student_id: localStorage.getItem("userId"),
        course_name: course?.title,
      });

      // console.log(response);
      if (response.data?.success) {
        setIsAlreadyEnrolled(response?.data?.enrolled)
      } else {
        setIsAlreadyEnrolled(false)
      }
    } catch (error) {
      setIsAlreadyEnrolled(false)
    }
  };

  useEffect(() => {
    alreadyEnrolled()
  }, []);

  const handleCancel = () => {
    setShowModal(false);
  };

  const enrolledInCourse = async () => {
    setShowModal(false);
    try {
      const response = await axios.post(webServiceUrl.upcoming_enrolled_requests, {
        student_id: localStorage.getItem("userId"),
        course_name: course?.title,
        course_dates: course?.date
      });
      // console.log(response);

      if (response.data?.success) {
        toast.success(response.data.message || "Enrollment successful!");
        alreadyEnrolled();
      } else {
        toast.error(response.data.message || "Something went wrong!");
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Server error occurred.");
    }
  };


  return (
    <>
      < ToastContainer />

      <div id="content-page" className="content-inner">
        <ConfirmModal
          show={showModal}
          title="Enroll in Course"
          message="Are you sure you want to enroll in this course?"
          onConfirm={enrolledInCourse}
          onCancel={handleCancel}
        />

        <Container>
          <Row className="justify-content-center">
            <Col lg="12">
            </Col>
          </Row>
          <Card>
            <Card.Body>
              <Row className="mt-5 pt-4">
                <Col lg={12} className="px-0 px-md-4 ">
                  <div className="product-detail-tabs">
                    <TabContainer activeKey={activeKey}>
                      <Nav
                        as="ul"
                        className="nav nav-tabs justify-content-center gap-4 mb-3 gap-lg-5 border-bottom"
                        id="product-tab"
                        role="tablist"
                      >
                        {tabConfig?.map((tab) => {
                          return (
                            <li className="nav-item" role="presentation">
                              <Nav.Link
                                to="#"
                                className="nav-link bg-transparent px-0 py-2 fs-5 rounded-0"
                                // name="ihfc"
                                data-bs-toggle="tab"
                                data-bs-target={`#${tab?.id}`}
                                eventKey={tab?.id}
                                role="tab"
                                aria-selected="true"
                                onClick={() => setActiveKey(tab?.id)}
                              // onClick={(e) => console.log(e.target.name)}
                              >
                                {tab?.label}
                              </Nav.Link>
                            </li>
                          )
                        })}
                      </Nav>

                      <TabContent>
                        <ActiveComponent program_id={course?.school_code} />
                      </TabContent>
                    </TabContainer>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </div>
    </>
  );
};

export default PGT_lesson;


